<template>
  <div v-if="bg" v-lazy:background-image="src" :error="error" :loading="loading" class="img"></div>
  <img v-else v-lazy="src" :error="error" :loading="loading" alt="">
</template>

<script>
  import IMG_SRC from '@/assets/ImgSrc'
  import { Lazyload } from 'vant'
  import Vue from 'vue'
  Vue.use(Lazyload, {
    error: IMG_SRC.IMG_ERROR,
    loading: IMG_SRC.IMG_DEFAULT,
  })

  export default {
    name: "img-lazy",
    props: {
      src: String,
      error: {
        type: String,
        default: IMG_SRC.IMG_ERROR
      },
      loading: {
        type: String,
        default: IMG_SRC.IMG_DEFAULT
      },
      bg: {
        type: Boolean,
        default: true
      }
    },
  }
</script>

<style scoped>
  .img {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
</style>